export default {
  maxFetchSize: 10000,
};
